import states from './states.json';

export const getStateName = (statE_ID = 1) => states.find(state => state.statE_ID === statE_ID);